import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/states/app.state';
import * as fromUserSelectors from 'src/app/store/selectors/user.selector';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PermissionType } from '../models/permission-type.enum';

@Injectable({
  providedIn: 'root'
})
export class PermissionCheckService {

  constructor(private store$: Store<AppState>) { }

  hasViewUsersPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_USERS) || permissions?.includes(PermissionType.MANAGE_USERS) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasViewTenantPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_TENANT) || permissions?.includes(PermissionType.MANAGE_TENANT) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasViewOrgUnitsPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_ORG_UNIT) || permissions?.includes(PermissionType.MANAGE_ORG_UNIT) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageOrgUnitsPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_ORG_UNIT) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageTenantPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_TENANT) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageDianaPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageUsersPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_USERS) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageRolesPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_ROLES) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasViewRolesPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_ROLES) || permissions?.includes(PermissionType.MANAGE_ROLES) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageAppointmentsPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_APPOINTMENTS) || false;
      })
    );
  }

  hasViewAppointmentsPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_APPOINTMENTS) || permissions?.includes(PermissionType.MANAGE_APPOINTMENTS) || false;
      })
    );
  }
  hasManageSettingPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_SETTING) || false;
      })
    );
  }

  hasViewSettingPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_SETTING) || permissions?.includes(PermissionType.MANAGE_SETTING) || permissions?.includes(PermissionType.MANAGE_DIANA) || false;
      })
    );
  }

  hasManageNewCustomerPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_NEW_CUSTOMER) || false;
      })
    );
  }

  hasViewMedicalHistoryPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_MEDICAL_HISTORY) || permissions?.includes(PermissionType.MANAGE_MEDICAL_HISTORY) || false;
      })
    );
  }
  hasManageMedicalHistoryPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_MEDICAL_HISTORY) || false;
      })
    );
  }
  hasViewCustomerPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.VIEW_CUSTOMER) || permissions?.includes(PermissionType.MANAGE_CUSTOMER) || false;
      })
    );
  }
  hasManageCustomerPermission$(): Observable<boolean> {
    return this.store$.select(fromUserSelectors.getUserPermissions).pipe(
      map(permissions => {
        return permissions?.includes(PermissionType.MANAGE_CUSTOMER) || false;
      })
    );
  }
}
